import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { 
  FiHome, FiBook, FiBookOpen, FiUser, FiLogOut, 
  FiChevronLeft, FiChevronRight, FiFileText, FiAward 
} from 'react-icons/fi';
import { useAuth } from '../../contexts/AuthContext';
import LogoutModal from '../LogoutModal/LogoutModal';
import './Sidebar.css';

const Sidebar = ({ isCollapsed, onToggle, isMobileOpen }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);

  const handleLogoutClick = () => {
    setShowLogoutModal(true);
  };

  const handleLogoutConfirm = () => {
    setLoggingOut(true);
    setTimeout(() => {
      logout();
      navigate('/login');
    }, 500);
  };

  const handleLogoutCancel = () => {
    setShowLogoutModal(false);
  };

  // Base menu items
  const baseMenuItems = [
    { path: '/home', icon: FiHome, label: 'Beranda' },
    { path: '/katalog', icon: FiBook, label: 'Katalog Buku' },
    { path: '/peminjaman', icon: FiBookOpen, label: 'Peminjaman Saya' },
  ];

  // Add Buku Saya, Jurnal, and Sitasi menu for dosen; Jurnal Dosen for mahasiswa
  const menuItems = user?.role === 'dosen'
    ? [...baseMenuItems, 
        { path: '/buku-saya', icon: FiBook, label: 'Buku Saya' },
        { path: '/jurnal', icon: FiFileText, label: 'Jurnal Saya' }, 
        { path: '/sitasi', icon: FiAward, label: 'Request Sitasi' },
        { path: '/profil', icon: FiUser, label: 'Profil' }
      ]
    : [...baseMenuItems, 
        { path: '/jurnal-dosen', icon: FiFileText, label: 'Jurnal Dosen' },
        { path: '/profil', icon: FiUser, label: 'Profil' }
      ];

  return (
    <aside className={`sidebar ${isCollapsed ? 'sidebar--collapsed' : ''} ${isMobileOpen ? 'sidebar--mobile-open' : ''}`}>
      {/* Logo */}
      <div className="sidebar__logo">
        <div className="sidebar__logo-icon">
          <img src="/images/logo.png" alt="STIKBAR" />
        </div>
        {!isCollapsed && (
          <div className="sidebar__logo-text">
            <span className="sidebar__logo-title">STIKBAR</span>
            <span className="sidebar__logo-subtitle">E-Library</span>
          </div>
        )}
      </div>

      {/* User Info */}
      {user && (
        <div className="sidebar__user">
          <div className="sidebar__user-avatar">
            {user.foto ? (
              <img src={`${user.foto}`} alt={user.nama} />
            ) : (
              user.nama?.charAt(0).toUpperCase() || 'U'
            )}
          </div>
          {!isCollapsed && (
            <div className="sidebar__user-info">
              <span className="sidebar__user-name">{user.nama}</span>
              <span className="sidebar__user-role">
                {user.role === 'dosen' ? 'Dosen' : 'Mahasiswa'}
              </span>
            </div>
          )}
        </div>
      )}

      {/* Navigation */}
      <nav className="sidebar__nav">
        <ul className="sidebar__menu">
          {menuItems.map((item) => (
            <li key={item.path} className="sidebar__menu-item">
              <NavLink 
                to={item.path} 
                className={({ isActive }) => 
                  `sidebar__menu-link ${isActive ? 'sidebar__menu-link--active' : ''}`
                }
                end={item.path === '/'}
              >
                <item.icon className="sidebar__menu-icon" />
                {!isCollapsed && <span className="sidebar__menu-label">{item.label}</span>}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {/* Footer */}
      <div className="sidebar__footer">
        <button className="sidebar__logout" onClick={handleLogoutClick}>
          <FiLogOut className="sidebar__menu-icon" />
          {!isCollapsed && <span>Keluar</span>}
        </button>
        
        <button className="sidebar__toggle" onClick={onToggle}>
          {isCollapsed ? <FiChevronRight /> : <FiChevronLeft />}
        </button>
      </div>

      {/* Logout Modal */}
      <LogoutModal 
        isOpen={showLogoutModal}
        onConfirm={handleLogoutConfirm}
        onCancel={handleLogoutCancel}
        loading={loggingOut}
      />
    </aside>
  );
};

export default Sidebar;
